import { render, staticRenderFns } from "./sanciones-table.vue?vue&type=template&id=15d949fa&"
import script from "./sanciones-table.vue?vue&type=script&lang=ts&"
export * from "./sanciones-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports